// Tillamook brand colors, formerly sourced from the (now retired)
// @tillamook/brand package. Color data lives in colors.json so it can be
// shared with the plain CommonJS scripts under scripts/.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import colors from './colors.json';

export function hexToRgb(hex) {
    let normalized = hex.replace('#', '');
    if (normalized.length === 3) {
        normalized = `${normalized[0]}${normalized[0]}${normalized[1]}${normalized[1]}${normalized[2]}${normalized[2]}`;
    }
    const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(normalized);
    return match
        ? [
              parseInt(match[1], 16),
              parseInt(match[2], 16),
              parseInt(match[3], 16),
          ]
        : null;
}

export function luminance(r, g, b) {
    const [rs, gs, bs] = [r, g, b].map(value => {
        value /= 255;
        return value <= 0.03928
            ? value / 12.92
            : Math.pow((value + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

export function contrast(rgb1, rgb2) {
    const l1 = luminance(rgb1[0], rgb1[1], rgb1[2]);
    const l2 = luminance(rgb2[0], rgb2[1], rgb2[2]);
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
}

export function checkColorContrast(color, background = '#ffffff') {
    const isColorHex = /^#([0-9A-F]{3}){1,2}$/i.test(color);
    const isBackgroundHex = /^#([0-9A-F]{3}){1,2}$/i.test(background);

    if (!isColorHex && !colors[color]) {
        console.warn(
            `checkColorContrast(): 1st ${color} is not defined in colors`
        );
        return undefined;
    }
    if (!isBackgroundHex && !colors[background]) {
        console.warn(
            `checkColorContrast(): 2st ${background} is not defined in colors`
        );
        return undefined;
    }

    return contrast(
        hexToRgb(isColorHex ? color : colors[color]),
        hexToRgb(isBackgroundHex ? background : colors[background])
    );
}

export default colors;
